import { Icon20 } from 'cio-design-library/icons'
import { useI18n } from 'builder/hooks/useI18n'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { AvailableAISuggestions, SectionNames, selectors } from 'builder/modules/resumeEditor'
import useImproveResumePanel from '../../ImproveResumePanel/hooks/useImproveResumePanel'
import {
  Container,
  SuggestionItem,
  SuggestionText,
  CompletionSuggestionItem,
  CompletionBadge,
  CompletionText,
  StyledStarsIcon,
  SuggestionBlock,
  StyledResumeScore,
  SuggestionsContainer,
  TailoredIconContainer,
} from './styles'

const tailoredSuggestsKey = 'builder.resume_editor.keywords.improve_resume_panel.tailored_suggests'

export const TabsResumeScore = () => {
  const { i18n } = useI18n()
  const { suggestions } = useTypedSelector(selectors.scoreSuggestions)
  const {
    isAICoverLetterActive,
    isAIProfileWriterActive,
    handleClickCoverLetter,
    handleSuggestionClick,
    getSuggestionScore,
    handleClickAIWriteProfileSummary,
    isSuggestionsActive,
    hasSkillsToTailor,
    keywordsCount,
    isResumeOptimizerFeatureEnabled,
    showAISuggestedJobTitleButton,
    handleAddTailored,
    isLinkedToJobPosting,
  } = useImproveResumePanel()

  const tailoredSuggestions = [
    {
      id: 'add_tailored_skills',
      name: i18n.t(`${tailoredSuggestsKey}.add_tailored_skills_anchor`),
      onClick: () => handleAddTailored(AvailableAISuggestions.skills),
      isActive: hasSkillsToTailor,
    },
    {
      id: 'add_profile_summary_keywords',
      name: i18n.t(`${tailoredSuggestsKey}.add_profile_summary_keywords_anchor`),
      onClick: () => handleAddTailored(SectionNames.profile),
      isActive: keywordsCount,
    },

    {
      id: 'apply_ai_suggested_job_title',
      name: i18n.t(`${tailoredSuggestsKey}.apply_ai_suggested_job_title`),
      onClick: () => handleAddTailored(AvailableAISuggestions.jobTitle),
      isActive: showAISuggestedJobTitleButton,
    },

    {
      id: 'add_work_experience_keywords',
      name: i18n.t(`${tailoredSuggestsKey}.add_work_experience_keywords_anchor`),
      onClick: () => handleAddTailored(SectionNames.workExperiences),
      isActive: keywordsCount,
    },
  ]

  const aiSuggestions = [
    {
      id: 'ai_profile',
      text: i18n.t(
        'builder.resume_editor.keywords.improve_resume_panel.ai_suggest.write_profile_summary_anchor',
      ),
      onClick: handleClickAIWriteProfileSummary,
      isActive: isAIProfileWriterActive,
    },
    {
      id: 'ai_cover_letter',
      text: i18n.t(
        'builder.resume_editor.keywords.improve_resume_panel.ai_suggest.create_cl_anchor',
      ),
      onClick: handleClickCoverLetter,
      isActive: isAICoverLetterActive,
    },
  ]

  return (
    <Container>
      <StyledResumeScore
        isImproveResumePanelDisabled
        customHeaderText={i18n.t(
          'builder.resume_editor.keywords.improve_resume_panel.resume_completeness',
        )}
      />

      <SuggestionBlock>
        {isResumeOptimizerFeatureEnabled &&
          isLinkedToJobPosting &&
          tailoredSuggestions.length > 0 && (
            <SuggestionsContainer>
              {tailoredSuggestions
                .filter(suggestion => suggestion.isActive)
                .map(suggestion => (
                  <SuggestionItem key={suggestion.id} onClick={suggestion.onClick}>
                    <TailoredIconContainer>
                      <Icon20.ArrowTarget2 />
                    </TailoredIconContainer>
                    <SuggestionText>{suggestion.name}</SuggestionText>
                  </SuggestionItem>
                ))}
            </SuggestionsContainer>
          )}

        {(isAICoverLetterActive || isAIProfileWriterActive) && aiSuggestions.length > 0 && (
          <SuggestionsContainer>
            {aiSuggestions
              .filter(suggestion => suggestion.isActive)
              .map(suggestion => (
                <SuggestionItem key={suggestion.id} onClick={suggestion.onClick}>
                  <StyledStarsIcon />
                  <SuggestionText>{suggestion.text}</SuggestionText>
                </SuggestionItem>
              ))}
          </SuggestionsContainer>
        )}

        {isSuggestionsActive && suggestions.length > 0 && (
          <SuggestionsContainer>
            {suggestions.map(suggestion => (
              <CompletionSuggestionItem
                key={suggestion.key}
                onClick={() => handleSuggestionClick(suggestion)}
              >
                <CompletionBadge>+{getSuggestionScore(suggestion)}</CompletionBadge>
                <CompletionText>{suggestion.text}</CompletionText>
              </CompletionSuggestionItem>
            ))}
          </SuggestionsContainer>
        )}
      </SuggestionBlock>
    </Container>
  )
}
